import React, { useEffect, useState } from "react";
import { View, Dimensions, ScrollView } from "react-native";
import CInput from "../../common/CInput";
import CustomButton from "../../common/CustomButton";
import CHeader from "./CommonComponants/Header";
import CDatePicker from "../../common/CDatePicker";
import CDropdown from "../../common/CDropdown";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";
import pickerConstant from "../../constant/pickerConstant";
import MainContainer from "./CommonComponants/MainContainer";
import { getCityState } from "../../api/tripInsurance";
import moment from "moment";
import { getUserDetails } from "../../api/apiManager";
import CPrefixInputDropdown from "../../common/CPrefixInputDropdown";
import CustomInput from "../../common/CustomInput";
import { COLORS, FONTS } from "../../constant";

const editableFlag = {
  emailId: true,
  gender: true,
  namePrefix: true,
  firstName: true,
  middleName: true,
  lastName: true,
  mobileNo: true,
  addressLine1: true,
  addressLine2: true,
  dob: true,
  city: true,
  state: true,
  pincode: true,
}
export default function PersonalDetails(props) {
  const [editableData, setEditableData] = useState(editableFlag);
  const styles = useStyles();
  const onlyAlphabetPattern = "[A-Za-z]";
  const emailPattern = /^([a-zA-Z0-9_\.]+)@([a-zA-Z0-9_\.]+)\.([a-zA-Z]{2,3})$/;
  const pincodePattern = /^[1-9]{1}\d{2}\s?\d{3}$/

  const isSmallDevice = Dimensions.get("window").width < 767;
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [cityList, setCityList] = useState([]);
  const [enableProceed, setEnableProceed] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [dob, setDob] = useState('');
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    navigate: "",
    actionButton: "",
  });

  const onHandleInput = (key, value) => {
    const dataObj = { ...data };
    dataObj[key] = value;
    setData(dataObj);
  };
  const handleDob = (val) => {
    const dataObj = { ...data };
    dataObj["dob"] = val;
    setData(dataObj);
  };
  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (alertModal.navigate == "Dashboard") props.navigation.navigate("Home");
  };

  useEffect(() => {
    if (
      data.firstName &&
      data.firstName != (undefined || "") &&
      data.lastName &&
      data.lastName != (undefined || "") &&
      data.gender &&
      data.gender != (undefined || "") &&
      data.prefix &&
      data.prefix != (undefined || "") &&
      data.address2 &&
      data.address2 != (undefined || "") &&
      data.zipCode &&
      data.zipCode != (undefined || "") &&
      data.address1 &&
      data.address1 != (undefined || "") &&
      data.state &&
      data.state != (undefined || "") &&
      data.emailId &&
      data.emailId != (undefined || "") &&
      data.city &&
      data.city != (undefined || "") &&
      emailPattern.test(data.emailId)
    ) {
      setEnableProceed(true);
    } else {
      console.log("data123123123",data)
      setEnableProceed(false);
    }
  }, [data]);
  const getPersonalDetails = () => {
    setLoading(true);
    getUserDetails()
      .then((res) => {
        setLoading(false);
        if (res) {
          handleProfileData(res);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const handleProfileData = (resData) => {
    console.log("ProfileDetailsData", resData);
    const profileData = {};
    const editableDataFlag = { ...editableFlag };
    profileData["firstName"] = (resData?.firstName) ? resData?.firstName : "";
    profileData["prefix"] = "";
    profileData["middleName"] = (resData?.middleName) ? resData?.middleName : "";
    profileData["lastName"] = (resData?.lastName) ? resData?.lastName : "";
    profileData["mobileNo"] = (resData?.mobileNo) ? resData?.mobileNo : "";
    profileData["emailId"] = (resData?.emailId) ? resData?.emailId : "";
    profileData["gender"] = (resData?.gender) ? resData?.gender : "";
    profileData["address1"] = (resData?.address1) ? resData?.address1 : "";
    profileData["address2"] = (resData?.address2) ? resData?.address2 : "";
    profileData["state"] = (resData?.state) ? resData?.state : "";
    profileData["city"] = (resData?.city) ? resData?.city : "";
    profileData["zipCode"] = (resData?.zipCode) ? resData?.zipCode : "";
    profileData["userId"] = (resData?.userId) ? resData?.userId : "";
    profileData["dob"] = (resData?.dateOfBirth) ? moment(resData?.dateOfBirth).format("DD-MM-YYYY") : "";
    // setCityList([{ value: `${resData?.city}`, label: `${resData?.city}` }]);
    setData(profileData);
    for (const key in profileData) {
      if (profileData.hasOwnProperty(key) && profileData[key] !== "" && (!["addressLine1", "addressLine2", "emailId", "city", "pincode","zipCode","gender"].includes(key))) {
        editableDataFlag[key] = false;
      }
    }
    setEditableData(editableDataFlag);
  }

  useEffect(() => {
    getPersonalDetails();
  }, []);

  useEffect(() => {
    onZipcodeChange(data?.zipCode || "");
  }, [data?.zipCode]);

  const onProceed = () => {
    let insuredDetailsObj = {
      ...data,
      dob : data?.dob != "" ? data?.dob : moment(dob).format("DD-MM-YYYY")
    } 
    const tempObj = { ...props.data, ...{ insuredDetails: insuredDetailsObj } };
    props.setData(tempObj);
    props.setScreen("NomineeDetails");
  };

  const onZipcodeChange = async (zipcode) => {
    onHandleInput("zipCode", zipcode);
    if (zipcode.length == 6) {
      getCityState({ pinCode: zipcode }).then((res) => {
        const resultArray = res?.data?.addresses.map((elm) => ({
          value: `${elm.cityName}`,
          label: `${elm.cityName}`,
        }));
        setCityList(resultArray);
        const dataObj = { ...data };
        dataObj["state"] = res?.data?.addresses[0]?.stateName;
        setData(dataObj);
      });
    }
  };

  return (
    <MainContainer>
       <ScrollView>
         <CHeader
           title="Customer Details"
           onPress={() => {
             props.setScreen("Benifits");
           }}
           showDesc={true}
           navigation=""
         />
         <View style={[styles.custInfoWrapper, { zIndex: 3 }]}>
           <View style={[styles.infoWrapper, { zIndex: 15 }]}>
             <CInput
               label="Mobile number"
               style={{ width: 230 }}
               value={data.mobileNo}
               mandatoryField={true}
               onChangeText={(value) => onHandleInput("mobileNo", value)}
               disable = {editableData.mobileNo}
             />
             <View style={{ zIndex: 14 }}>
               <CPrefixInputDropdown
                 label="First name"
                 value={data.firstName}
                 onSelect={(value) => onHandleInput("prefix", value)}
                 pickerValue={data?.prefix}
                 items={pickerConstant.titleList}
                 mandatoryField={true}
                 disable = {editableData.firstName}
               />
             </View>
             <View style={{ zIndex: 13 }}>
               <CInput
                 inputType="alpha"
                 maxLength={20}
                 label="Middle name"
                 style={{ width: 230 }}
                 pattern={onlyAlphabetPattern}
                 value={data.middleName}
                 onChangeText={(value) => onHandleInput("middleName", value)}
                 disable = {editableData.middleName}
               />
             </View>
             <View style={{ zIndex: 12 }}>
               <CInput
                 label="Last name"
                 style={{ width: 230 }}
                 value={data.lastName}
                 mandatoryField={true}
                 onChangeText={(value) => onHandleInput("lastName", value)}
                 disable = {editableData.lastName}
               />
             </View>
  
             <View style={{ zIndex: 11 }}>
               <CDropdown
                 label="Gender"
                 value={
                   data?.gender == "F" ||  data?.gender == "Female"
                     ? "Female"
                     : data?.gender == "M" || data?.gender == "Male"
                       ? "Male"
                       : data?.gender == "O" ||  data?.gender == "Others" ? "Others" :""
                 }
                 mandatoryField={true}
                 onSelect={(value) => onHandleInput("gender", value)}
                 items={pickerConstant.gender}
                 style={styles.inputWidth}
                 disable = {!editableData.gender}
               />
             </View>
  
             <View style={{ zIndex: 10 }}>
               { data.dob != ""  ? (
                 <CInput
                   label="Date of birth"
                   style={{ width: 230 }}
                   value={data.dob}
                   mandatoryField={true}
                   
                 />
               ) : (
                 <CDatePicker
                   isMobile={isSmallDevice}
                   value={  dob
                   }
                   label="Date of birth"
                   onDateChange={(val) => {
                    setDob(val)
                  }}
                   mandatoryField={true}
                 />
               )}
             </View>
             <View style={{ zIndex: 9 }}>
               <CInput
                 label="Address Line 1"
                 maxLength={30}
                 style={{ width: 230 }}
                 value={data.address1}
                 mandatoryField={true}
                 onChangeText={(value) => onHandleInput("address1", value)}
                 disable = {editableData.address1}
               />
             </View>
             <View style={{ zIndex: 8 }}>
               <CInput
                 label="Address Line 2"
                 maxLength={30}
                 style={{ width: 230 }}
                 value={data.address2}
                 mandatoryField={true}
                 onChangeText={(value) => onHandleInput("address2", value)}
                 disable = {editableData.address2}
               />
             </View>
             <View style={{ zIndex: 7 }}>
               <CInput
                 label="Pin Code"
                 style={{ width: 230 }}
                 value={data.zipCode}
                 onChangeText={(value) => onZipcodeChange(value)}
                 maxLength={6}
                 inputType="numeric"
                 mandatoryField={true}
                 disable = {editableData.zipCode}
                 errorText = {pincodePattern.test(data.zipCode) ?  "" : "Enter valid pincode"}
               />
             </View>
  
             <View style={{ zIndex: 6 }}>
               <CDropdown
                 label="City"
                 style={{ width: 230 }}
                 value={data.city}
                 items={cityList}
                 onSelect={(value) => onHandleInput("city", value)}
                 mandatoryField={true}
             
               />
             </View>
             <View style={{ zIndex: 5 }}>
               <CInput
                 label="State"
                 value={data.state}
                 style={{ width: 230 }}
                 mandatoryField={true}
                 disable = {editableData.state}
               />
             </View>
             <View style={{ zIndex: 4 }}>
  
               <CustomInput
                 flexDirection={"column"}
                 label="Email"
                 onValueChanged={(value) => onHandleInput("emailId", value)}
                 value={data.emailId}
                 requiredEndText={true}
                 blurOnSubmit={false}
                 pattern={emailPattern}
                 errorMessage={"Please enter valid email id"}
                 mandatoryField={true}
                 style={{
                   borderRadius: 10,
                   backgroundColor: 'white',
                   borderWidth: 1,
                   borderColor: '#ccc',
                   marginBottom: 5,
                   paddingHorizontal: 20,
                   color: COLORS.darkBlack,
                   fontFamily: FONTS.InterMedium,
                   fontSize: 16,
                   height: 36.5,
                   width: 230
                 }}
                 secureTextEntry={false}
                 maxLength={100}
                 disable = {editableData.emailId}
               />
             </View>
           </View>
         </View>
  
         <View style={[styles.footer, { zIndex: 2 }]}>
           <CustomButton
             text="Proceed"
             onPress={!enableProceed ? null : () => onProceed()}
             disable={!enableProceed}
           />
         </View>
         {alertModalVisible && (
           <View style={styles.overlayViewStyle}>
             <ModalAlert
               title={alertModal.title}
               status={alertModal.status}
               message={alertModal.message}
               navigateScreen={alertModal.navigateScreen}
               actionButton={"OK"}
               onCloseModal={onCloseModal}
             />
           </View>
         )}
  
         {loading && <Loader />}
       </ScrollView>
     </MainContainer>
  );
}
const useStyles = CreateResponsiveStyle(
  {
    inputWidth: {
      width: 230,
    },
    footer: {
      flexDirection: "row",
      alignSelf: "flex-end",
      width: 220,
      height: 44,
      marginVertical: 30,
      marginRight: 30,
    },
    custInfoWrapper: {
      gap: 20,
      paddingHorizontal: 71,
    },
    infoWrapper: {
      flexDirection: "row",
      gap: 20,
      flexWrap: "wrap",
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {
      infoWrapper: {
        flexWrap: "wrap",
        gap: 30,
      },
      custInfoWrapper: {
        paddingHorizontal: 0,
        paddingLeft: 40,
        paddingRight: 20,
      },
    },
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
      infoWrapper: {
        flexDirection: "column",
        gap: 10,
        marginTop: -10,
      },
      custInfoWrapper: {
        alignItems: "center",
      },
      footer: {
        alignSelf: "center",
        marginTop: 30,
      },
      inputWidth: {
        width: 200,
      },
    },
  }
);
